/* eslint-disable react/self-closing-comp */
// material
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
import ClientComplaint from '../components/client/ClientComplaint';

// Menu
import Menu from '../components/Menu';
import ClientMenuLeft from './common/ClientMenuLeft';
// components
import Page from '../components/Page';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 1000,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ComplaintClientPage() {
  return (
    <RootStyle title="Déposer votre plainte | Gestion des plaintes">
      <Menu />
      <ClientMenuLeft />

      <Container>
        <ContentStyle>
          <ClientComplaint />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
